import assert from 'assert';

import objectToGetParams from 'react-share/lib/utils/objectToGetParams';
import createShareButton from 'react-share/lib/utils/createShareButton';

import { FACEBOOK_APP_ID } from '../../../constants';

function facebookMessengerLink(url, { display, to }) {
  assert(url, 'facebookmessenger.url');

  return (
    'fb-messenger://share' +
    objectToGetParams({
      link: url,
      sharing_reference: 'send-dialog',
      app_id: FACEBOOK_APP_ID,
      to,
      display,
    })
  );
}

const FacebookMessengerShareButton = createShareButton(
  'facebookmessenger',
  facebookMessengerLink,
  props => ({
    display: props.display,
    to: props.to,
  }),
  {},
  {
    windowWidth: 550,
    windowHeight: 400,
  }
);

export default FacebookMessengerShareButton;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/FacebookMessengerShareButton.js